<template>

	<!-- Image container -->
	<div class="zoom-container" @mouseenter="handleMouseEnter" @mousemove="handleMouseMove" @mouseleave="handleMouseLeave">

		<!-- Normal image -->
		<img ref="normal" class="normal-image" :src="src" :alt="title" >

		<!-- Zoomed in image -->
		<img
			ref="zoomed"
			class="zoomed-image"
			:src="zoomedSrc || src"
			:alt="title"
			:style="{
				transform: `scale(${scale})`,
				left: `${zoomedX}px`,
				top: `${zoomedY}px`
			}"
		>
	</div>

</template>

<script>

	export default {
		props: {
			src: String,
			zoomedSrc: String,
			title: String,
			scale: {
				type: Number,
				default: 1
			},
			disabled: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				zoomedX: 0,
				zoomedY: 0,
			};
		},

		methods: {
			handleMouseEnter() {
				if (this.disabled) return;

				let { normal, zoomed } = this.$refs;
				normal.style.opacity = 0;
				zoomed.style.opacity = 1;
			},

			handleMouseLeave() {
				if (this.disabled) return;

				let { normal, zoomed } = this.$refs;
				normal.style.opacity = 1;
				zoomed.style.opacity = 0;
			},

			handleMouseMove(event) {
				if (this.disabled) return;

				let { normal, zoomed } = this.$refs;

				let boundingRect = this.$el.getBoundingClientRect();
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
				let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

				let offsetX = boundingRect.left + scrollLeft;
				let offsetY = boundingRect.top + scrollTop;

				let relativeX = event.clientX - offsetX + window.pageXOffset;
				let relativeY = event.clientY - offsetY + window.pageYOffset;

				let normalFactorX = relativeX / normal.offsetWidth;
				let normalFactorY = relativeY / normal.offsetHeight;

				this.zoomedX = -(normalFactorX * (zoomed.offsetWidth * this.scale - normal.offsetWidth));
				this.zoomedY = -(normalFactorY * (zoomed.offsetHeight * this.scale - normal.offsetHeight));
			}
		}
	}

</script>

<style type="text/css">

	.zoom-container {
		position: relative;
		overflow: hidden;
	}

	.zoom-container .normal-image {
		width: 100%;
	}

	.zoom-container .zoomed-image {
		pointer-events: none;
		position: absolute;
		opacity: 0;
		transform-origin: top left;
	}

</style>
